import { getPropCacheMixin } from "../utils/cache.js";
export default getPropCacheMixin('$listeners', 'qListeners');